import $ from 'jquery';
import '../scss/hub-main.scss';

$(document).ready(function () {
    if ($(".dashMenu")) {
        if (window.matchMedia('(max-width: 991px)').matches) {
            if ($("#footer-spacer").length) {
                $('#footer-spacer').remove();
            } else {
                $('footer').after("<div id='footer-spacer' style='height: 70px; background-color: rgb(240, 240, 240);' ></div>");
            }
        }
        $(window).resize(function () {
            if (window.matchMedia('(max-width: 991px)').matches) {
                if ($("#footer-spacer").length) {

                } else {
                    $("footer").after("<div id='footer-spacer' style='height: 70px; background-color: rgb(240, 240, 240);' ></div>");
                }
            } else if (window.matchMedia('(min-width: 992px)').matches) {
                $('#footer-spacer').remove();
            }
        });
    }
    /*********************************
     * Ajax Requests for download
     ********************************/
    var urlParams = new URLSearchParams(window.location.search);
    var filters = {};
    var renderData = null;
    var renderSelector = "#downloads-render";

    //Intiate the download
    if ($(renderSelector).length) {
        renderData = $(renderSelector).data("result");
        quickRender(filters);
    }

    //If category has been provided then load that category
    if (urlParams.has('category')) {
        filters.category = urlParams.get('category');
        quickRender(filters);
    }

    $(renderSelector).on("click", '.download_category_box', function () {
        filters.category = $(this).data("id");
        quickRender(filters);
    });

    function quickRender(filter) {
        ajaxLoading("d-none", "d-block");
        $.ajax({
            url: '/digitalhub/results/' + renderData + '?filters=' + stringfy(filter),
            success: function (profiles) {
                ajaxLoading("d-block", "d-none");
                $(renderSelector).html(profiles);
            }
        });
    }

    function stringfy(obj) {
        var param = "";
        $.each(obj, function (key, value) {
            param += key + ":" + value + ";";
        });
        return param
    }

    function ajaxLoading(show, hide) {
        $(".ajax-loading").removeClass(show).addClass(hide);
    }

    //DOWNLOAD NOTIFICATIONS
    var confirmSubscribeModal = null;
    if (document.querySelector('#confirmSubscribe')) {
        confirmSubscribeModal = new bootstrap.Modal(document.querySelector('#confirmSubscribe'));
        $(renderSelector).on("click", '.category_notification', function () {
            let item = $(this);
            let confirmSubscribeEl = $("#confirmSubscribe");
            if (item.hasClass("active")) {
                confirmSubscribeEl.find(".modal-title").text("Vuoi disattivare le notifiche per questa categoria " + item.data('category').title + "?");
                confirmSubscribeEl.find(".modal-subtitle").text("In questo modo non ti arriverà più alcuna notifica via mail quando verranno caricati nuovi contenuti.");
            } else {
                confirmSubscribeEl.find(".modal-title").text("Vuoi attivare le notifiche per la categoria " + item.data('category').title + "?");
                confirmSubscribeEl.find(".modal-subtitle").text("In questo modo ti arriverà una notifica via mail quando verranno caricati nuovi contenuti.");
            }

            confirmSubscribeModal.show();
            $(".download-categories-list .category_notification").removeClass("action-active");
            $(this).addClass("action-active");
        });
    }

    $(".btn-data-notification").click(function () {
        let action = $(this).data("action");
        confirmSubscribeModal.hide();

        if (action === "proceed") {
            subscriptionDownload();
        }

        $(".download-categories-list .category_notification").removeClass("action-active");
    })


    function subscriptionDownload() {
        let item = $(".action-active");
        let type = '';
        let action = item.data("action");

        if (item.hasClass("active")) {
            type = 'disable'
        } else if (item.hasClass("disable")) {
            type = 'active'
        } else {
            type = 'active'
        }
        let catChildrens = item.data('category').children;
        $.ajax({
            type: "POST",
            url: '/digitalhub/results/downloads/notification',
            data: {id: item.data("id"), trigger: type},
            success: function () {
                if (item.hasClass('found-in')) {
                    item.removeClass('found-in');
                    item.addClass('active');
                } else if (item.hasClass('active')) {
                    item.removeClass("active");
                } else {
                    item.addClass("active");
                }
            }
        });
        if (action === "hide") {
            item.parent().remove();
            var container = $(".category-notification-profile").length;
            if (container === 0) {
                $(".profile-notification-title").text("Nessuna Notifica");
            }
        }
        if (catChildrens && type === 'active') {
            $.each(catChildrens, function (index, value) {
                $.ajax({
                    type: "POST",
                    url: '/digitalhub/results/downloads/notification',
                    data: {id: value, trigger: 'disable'},
                });
            });
        }
    }

    //DOWNLOAD FAVOURITE
    $(renderSelector).on("click", '.download-favorite', function () {
        let item = $(this);
        let type = item.hasClass("active") ? "disable" : "active";
        $.ajax({
            type: "POST",
            url: '/digitalhub/results/downloads/favourite',
            data: {id: item.data("id"), trigger: type},
            success: function (data) {

                item.find("span").text(data.label);
                $(renderSelector).find(".download-item-" + item.data("id")).remove();

                if (type === "active") {
                    item.addClass("active");
                } else {
                    item.removeClass("active");

                }
            }
        });
        let prefcontainer = $(".preferiti-check-lenght").length;
        if (prefcontainer === 1) {
            $(".preferiti-check-title").text("Nessun file nei Preferiti");
            $(".ordinator").css('display', 'none');
        }

    });
    //DOWNLOAD SORTING
    $(renderSelector).on("change", '#reorder', function () {
        filters.sort = $(this).val();
        filters.sortby = $(this).children(":selected").data("id");
        quickRender(filters);
    });
    //SEARCH DATA
    // $(".ajax-search").click(function(e){
    //     $keyword = $(".search-bar").val();
    //     if($keyword!=""){
    //         filters["search"]     = $keyword;
    //         quickRender(filters);
    //         searchStore($keyword);
    //     }
    // })

    $('.search-bar').keyup(function (e) {
        if (e.keyCode === 13) {
            let keyword = $(this).val();
            if (keyword !== '') {
                filters.search = keyword;
                quickRender(filters);
                searchStore(keyword);
            }
        }
    });
    //SEARCH FROM THIRD PARTY URL
    let searchParams = new URLSearchParams(window.location.search);
    let param = searchParams.get('keyword');
    if (param) {
        setTimeout(function () {
            $(".search-bar").val(param);
            filters.search = param;
            quickRender(filters);
            searchStore(param);
        }, 100)

    }

    //SEARCH TRACKING PROBLEM
    function searchStore(keyword) {
        $.ajax({
            type: "POST",
            url: '/digitalhub/track/search',
            data: {keyword: keyword},
            success: function (data) {
            }
        });
    }

    //ON CLEAR RETURN ALL RESULTS
    $(".search-bar").on('input', function () {
        let keyword = $(this).val();
        if (keyword.length <= 0) {
            filters.search = "";
            quickRender(filters);
        }
    });

    /****************************
     * LOGIN/REGISTER SCRIPT
     ****************************/

    $(".frontend__show").click(function () {
        $(this).parent().find('.password').attr('type', function (index, attr) {
            return attr === 'text' ? 'password' : 'text';
        });
        $(this).toggleClass("fa-eye-slash", "fa-eye");
    })

    $('.btn-data-confirm-password').click(function () {
        window.alert = function alert(message) {
            $(".btn-data-confirm-password-error").show().text(message);

        }
    })
    //pop un password
    $('#registerPassword').focus(function () {
        // register-speeche-bubble
        $(".register-speeche-bubble").show();
    }).focusout(function () {
        // register-speeche-bubble
        $(".register-speeche-bubble").hide();
    });

    /****************************
     * TRACKING
     ****************************/
    $(renderSelector).on("click", '.track-event', function () {
        let item = $(this);
        let type = item.data("track-type");
        let id = item.data("track-id");

        $.ajax({
            type: "POST",
            url: '/digitalhub/track/store',
            data: {event_type: type, event_value: id},
            success: function (data) {
            }
        });
    });

    $(renderSelector).on("click", '.dropbtn', function () {
        $("#myDropdown").toggleClass("show");
    });

    $("body").click(function (e) {
        if (!$(e.target).hasClass("dropbtn") && !$(e.target).hasClass("date-input")) {
            let selector = $("#myDropdown");
            if (selector.hasClass("show")) {
                selector.removeClass("show")
            }
        }

    });

    /****************************
     * POPUP TICKET DETAIL
     ****************************/
    $(renderSelector).on("mouseover", '.ticket-detail', function () {
        popupRenderTicket($(this));
        $(".pop-closer").hide();
    });

    $(renderSelector).on("mouseleave", '.ticket-detail', function () {
        $(".speech-bg").hide();
        $('.download-list .active-row').removeClass("active-row");
    });

    $(renderSelector).on("click", '.ticket-detail-mobile', function () {
        popupRenderTicket($(this));
        $(".pop-closer").show();
    });

    $(renderSelector).on("click", document, function (event) {
        if (!$(event.target).closest(".ticket-detail-mobile").length) {
            $(".speech-bg").hide();
            $('.download-list .active-row').removeClass("active-row");
        }
    });


    function popupRenderTicket(item) {
        let popupHeight;
        let popupWidth;
        let speech_bg = $(".speech-bg");

        if (window.matchMedia("(max-width: 767px)").matches) {
            popupHeight = speech_bg.outerHeight() + 10;
            popupWidth = speech_bg.outerWidth() - 120;
        } else if (window.matchMedia("(max-width: 1199px)").matches) {
            popupHeight = speech_bg.outerHeight() + 100;
            popupWidth = speech_bg.outerWidth() - 120;
        } else {
            popupHeight = speech_bg.outerHeight() / 2 - 10;
            popupWidth = speech_bg.outerWidth() + 30;
        }
        let position = $(item).position();
        let top = position.top - popupHeight;
        let left = position.left - popupWidth;

        //Render Data
        let data = $(item).data("ticket");
        let lastmsg = $(item).find(".ticket-summary").html();
        let lastmsgdate = ($(item).data("lastmsgdate"));
        let msgurl = ($(item).data("msgurl"));
        let lastsender = ($(item).data("lastsender"));
        $(".box-speech a.ticket-button").attr("href", msgurl);
        $(".box-speech .title").text(data.title);
        $(".box-speech .category").text(data.category);
        $(".box-speech .lastSender").text(lastsender);
        $(".box-speech .lastMessageText").html(lastmsg);
        $(".box-speech .lastMessageDate").text("(" + lastmsgdate + ")");
        speech_bg.css("top", top).css("left", left).show();
        $('.download-list .active-row').removeClass("active-row");
        $(item).parent().parent().parent().addClass("active-row");
    }


    $(renderSelector).on("click", '.pop-closer', function () {
        $('.download-list .active-row').removeClass("active-row");
        $(".speech-bg").hide();
    });

    $(renderSelector).on("click", '.resetta', function () {
        $('.date-resetted').val('')
            .attr('type', 'text')
            .attr('type', 'date');
    });

    // TICKET CREATION MODAL
    var createTicketModal = null;
    if (document.querySelector("#createTicket")) {
        createTicketModal = new bootstrap.Modal(document.querySelector("#createTicket"));
        $(renderSelector).on("click", '.new_ticket', function () {
            createTicketModal.show();
        });
    }

    // TICKET REOPEN MODAL
    var reopenTicketModal = null;
    if (document.querySelector("#reopenTicket")) {
        reopenTicketModal = new bootstrap.Modal(document.querySelector("#reopenTicket"));
        $(renderSelector).on("click", '.ticket-button-open', function () {
            reopenTicketModal.show();
        });
    }

    // TICKET CLOSE MODAL
    var closeTicketModal = null;
    if (document.querySelector("#closeTicket")) {
        closeTicketModal = new bootstrap.Modal(document.querySelector("#closeTicket"));
        $(renderSelector).on("click", '.ticket-button-close', function () {
            closeTicketModal.show();
        });
    }

    $(".status-changer").click(function () {
        let item = $(this);
        $.ajax({
            type: "POST",
            url: '/digitalhub/results/update/ticket',
            data: {id: item.data("id"), type: item.data("type")},
            success: function (data) {
                closeTicketModal.hide();
                reopenTicketModal.hide();
                if (data.type === "success") {
                    quickRender(filters);
                }
                $.oc.flashMsg({
                    'text': data.msg,
                    'class': data.type,
                    'interval': 5
                })
            }

        });
    });
    // SEND MESSAGE FOR TICKET
    $(renderSelector).on("submit", '#commnetForm', function (event) {
        event.preventDefault();
        let formData = new FormData(this);

        $.ajax({
            type: "POST",
            url: '/digitalhub/results/update/comment',
            data: formData,
            success: function (data) {
                if (data.type === "success") {
                    quickRender(filters);
                }
                $.oc.flashMsg({
                    'text': data.msg,
                    'class': data.type,
                    'interval': 5
                })
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    // CREATE TICKET
    $("#ticketProcess").submit(function (event) {
        event.preventDefault();
        let formData = new FormData(this);
        // ticket
        $.ajax({
            type: "POST",
            url: '/digitalhub/results/create/ticket',
            data: formData,
            success: function (data) {
                if (data.type === "success") {
                    quickRender(filters);
                    createTicketModal.hide();
                }
                $.oc.flashMsg({
                    'text': data.msg,
                    'class': data.type,
                    'interval': 5
                })
            },
            cache: false,
            contentType: false,
            processData: false
        });
    });

    $(renderSelector).on("change", '#categoriesFilter', function () {
        filters.category = $(this).val();
        filters.categoryby = 'category_id';
        quickRender(filters);
    });

    $(renderSelector).on("change", '#stateFilter', function () {
        filters.status = $(this).val();
        filters.statusby = "status_id";
        quickRender(filters);
    });

    $(renderSelector).on("click", '#dateFilter,#dateReset', function () {
        filters.dateFrom = $('input[name="dateFrom"]').val();
        filters.dateTo = $('input[name="dateTo"]').val();
        filters.dateby = "created_at";
        quickRender(filters);
    });

    //Popup on Dashboard for creating tickets
    $('.new_ticket').click(function () {
        createTicketModal.show();
    });

    $.ajax({
        type: "GET",
        url: "/digitalhub/results/settings",
        success: function (result) {
            $('.buttonLinkToHub').attr("href", "/" + result)
        },
    });

});
